import { AgencyPermitRequirement } from '../api/models'

export const AgencyPermitRequirementDisplayNames: Record<AgencyPermitRequirement, string> = {
  [AgencyPermitRequirement.Required]: 'Required',
  [AgencyPermitRequirement.Recommended]: 'Recommended',
  [AgencyPermitRequirement.RequiredAfterFalseAlarmLimit]: 'Required After False Alarm Limit',
  [AgencyPermitRequirement.NotRequired]: 'Not Required',
  [AgencyPermitRequirement.Unknown]: 'Unknown'
}
